import { render, staticRenderFns } from "./addOpen.vue?vue&type=template&id=6e620a6c&scoped=true&"
import script from "./addOpen.vue?vue&type=script&lang=ts&"
export * from "./addOpen.vue?vue&type=script&lang=ts&"
import style0 from "./addOpen.vue?vue&type=style&index=0&id=6e620a6c&lang=scss&scoped=true&"
import style1 from "./addOpen.vue?vue&type=style&index=1&id=6e620a6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e620a6c",
  null
  
)

export default component.exports